module.exports = "{{ 'periodic_tasks.repeater_configurator.at' | translate }} {{\nTaskDetailsCtrl.taskDetails.repeater_config | whichWhatDisplay }}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/app/components/periodic_tasks/task_details/display_which_what.html
// module id = 754
// module chunks = 0